module.exports = __webpack_public_path__ + "img/toolbar_online_service.779148c0.png";